import RestaurantCard, { withPromotedLabel } from "./RestaurantCard";
import { useEffect, useState, useContext } from "react";
import Shimmer from "./Shimmer";
import { Link } from "react-router";
import useOnlineStatus from "../utils/useOnlineStatus";
import UserContext from "../utils/userContext";

const Body = () => {

    //Local State variable - Super Powerful variable
    const [listOfRestaurants, setListOfRestaurants] = useState([]);
    const [filteredRestaurant, setFilteredRestaurant] = useState([]);

    const [searchText, setSearchText] = useState("");

    const RestaurantCardPromoted = withPromotedLabel(RestaurantCard);

    // console.log("render")


    //use Effect will take two arguments first one is a call back funciton and 
    //second one will be dependency array
    //callback fn will be called once the render cycle is finished
    useEffect(() => {
        fetchData();
    }, []);

    //we are directly fetching the data form the swiggy API's 
    //Using edu cors
    const ApiKey = '4e7a00598aebdb3d';
    const EDUCORS_URL = 'https://educorssolver.host/api/getData';
    // Target URL from you want to fetch data m ,ex-github api
    const Target = 'https://foodfire.onrender.com/api/restaurants?lat=21.1702401&lng=72.83106070000001&page_type=DESKTOP_WEB_LISTING';

    const fetchData = async () => {
        const data = await fetch(
            `${EDUCORS_URL}?ApiKey=${ApiKey}&Target=${encodeURIComponent(Target)}`
        );

        const json = await data.json();

        console.log(json);
        //Trying to implement this from chetananda and it worked Baby!..... and I implemented this funciton because everytime the cards[i]
        //value changes in the API.
        // initialize checkJsonData() function to check Swiggy Restaurant data
        function checkJsonData(jsonData) {

            // if (!jsonData?.data?.cards) return [];  new thing added watching the deepseek

            for (let i = 0; i < jsonData?.data?.cards.length; i++) {

                // initialize checkData for Swiggy Restaurant data
                let checkData =
                    json?.data?.cards[i]?.card?.card?.gridElements?.infoWithStyle
                        ?.restaurants;

                // if checkData is not undefined then return it
                if (checkData !== undefined) {
                    return checkData;
                }

            }
            return [];
        }

        // call the checkJsonData() function which return Swiggy Restaurant data
        const resData = checkJsonData(json);
        



        //optional chaining == ?.(symbol)
        // setListOfRestaurants(json?.data?.cards[4]?.card?.card?.gridElements?.infoWithStyle?.restaurants);
        // setFilteredRestaurant(json?.data?.cards[4]?.card?.card?.gridElements?.infoWithStyle?.restaurants);

        setListOfRestaurants(resData);
        setFilteredRestaurant(resData);
    }

    // console.log(listOfRestaurants);
    const onlineStatus = useOnlineStatus();
    if (onlineStatus == false) return <h1>
        Looks like you are fucking offline, Are you stupid or something, Don't even know how to turn on your Internet!!
    </h1>

    //Conditional Rendering
    // if(listOfRestaurants.length == 0){
    //     return < Shimmer />;
    // }

    //Another way for the above conditional rendering is ternery operator

    const { setUserName, loggedInUser } = useContext(UserContext);


    return listOfRestaurants.length == 0 ? < Shimmer /> : (
        <div className="body max-w-7xl mx-auto p-4">
            {/* filter and search section */}
            <div className="filter flex flex-wrap justify-between items-center mb-6 bg-gray-50 p-4 rounded-lg shadow-md">
                {/* search Bar */}
                <div className="search flex items-center bg-white border border-gray-300 rounded-full shadow-sm">
                    <input type="text" className="px-4 py-2 w-64 rounded-l-full focus:outline-none"
                        value={searchText}
                        onChange={
                            (e) => setSearchText(e.target.value)

                        }
                    />
                    <button onClick={() => {
                        //filter the restaurant cards and update the UI
                        //searchText
                        // console.log(searchText);

                        const filteredRestaurant = listOfRestaurants.filter((res) =>
                            res.info.name.toLowerCase().includes(searchText.toLowerCase())
                        );

                        setFilteredRestaurant(filteredRestaurant);

                    }} className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-r-full transition duration-300">Search</button>

                </div>
            {/* for the blow className p-4 m-4 flex items-center */}
                <div className="">  
                    {/*Filter to top rated Restaurants */}
                    <button
                        className="px-6 py-2 bg-green-600 text-white rounded-lg shadow-md hover:bg-green-700 transition duration-300"
                        onClick={() => {
                            const filteredList = listOfRestaurants.filter((res) => parseFloat(res.info.avgRating) >= 4.5                     
                        );

                            setFilteredRestaurant(filteredList);
                            console.log("Button clicked")
                        }}
                    >Top Rated Restaurants
                    </button>
                </div>
                <div className="search flex items-center space-x-2">
                    <label className="font-semibold">Username : </label>
                    <input className="border border-gray-300 p-2 rounded-md focus:outline-blue-600"
                        value={loggedInUser}
                        onChange={
                            (e) => setUserName(e.target.value)
                        } />
                </div>
            </div>
            {/* Restaurant card section */}
            <div className="res-container grid grid-cols-4 gap-6 p-4" >

                {
                    filteredRestaurant.map((restaurant) => (
                        <Link key={restaurant.info.id} to={"/restaurants/" + restaurant.info.id}
                        className="transform hover:scale-105 transition duration-300"
                        >

                            {/* As Promoted option was not there so I have used the .veg option from the data */}

                            {restaurant.info.veg ? (<RestaurantCardPromoted resData={restaurant} />) : (<RestaurantCard resData={restaurant} />)}
                        </Link>
                    ))

                }
            </div>
        </div>
    )
}

export default Body;